import React from 'react';
import Products from 'components/features/Products/Products';

const CymbalsPage = () => (
  <>
    <Products category="cymbals" />
  </>
);

export default CymbalsPage;
